var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"appear":"","mode":"out-in","duration":"200","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeUp"}},[_c('router-view',{key:_vm.$router.path,attrs:{"appear":""}})],1),_c('CookiesAgreementComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }